import(/* webpackMode: "eager" */ "/codebuild/output/src63316654/src/craft-stadium/frontend/user/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src63316654/src/craft-stadium/frontend/user/node_modules/next/dist/client/link.js");
